<template>
  <!-- <div class="container">

    <div class="slider-list">
      <div class="slider-wrapper" v-for="item in 8" :key="item">
        <input class="slider" type="range" id="slider" min="0" max="100" value="50">
      </div>
    </div>


  </div> -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>


  export default {
    components: {

    },
    setup() {
      // const sliderValue = ref(50); // 初始化滑块值为 50
      // return {
      //   sliderValue,
      // };
    },
  };
</script>

<style>
  .container {
    background-color: rgb(37, 41, 44);
    /* background-image: url('@/assets/bg1.jpg'); */
    /* 使用 src 目录中的图片 */
    background-size: cover;
    /* 保证图片完全显示 */
    background-repeat: no-repeat;
    /* 防止背景图片重复 */
    background-position: center;
    /* 保证图片居中显示 */

    /* 保证图片居中显示 */
    /* 背景图片填充 */
    width: 100%;
    height: 100%;
    /* background-size: 100%; */
    background-repeat: no-repeat;
    /* 背景图片填充 */
  }

  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .slider-list {
    display: flex;
    justify-content: space-between;
    height: 400px;
  }

  .slider-wrapper {

    /* 让滑块竖直 */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    /* 设置容器的宽度 */
    height: 270px;
    /* 设置容器的高度 */
    /* transform: rotate(270deg); */
  }

  .slider {
    -webkit-appearance: none;
    /* 兼容 WebKit */
    appearance: none;
    /* 兼容其他浏览器 */
    writing-mode: vertical-lr;
    /* 让滑块竖向显示 */
    outline: none;
    /* 去除默认轮廓 */
    background: rgba(16, 177, 172, 1);
    /* 轨道背景色 */
    height: 100%;
    /* 使用容器高度 */
    width: 7px;
    /* 滑块的宽度（竖向时相当于滑块的高度） */
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    overflow: visible !important;
    /* border-radius: 5px; */
    /* 可选：设置圆角 */
  }


  /* 自定义滑块的指示器（thumb） */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-repeat: no-repeat !important;
    width: 30px !important;
    height: 40px !important;
    background: url('@/assets/solid.png') no-repeat center center;
    background-size: 100% 100% !important;
  }
</style>